
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { setFocusToInput } from '@/utils/functions';
import { DataService } from '@/service/DataService';
import { RoomSpace } from '@/utils/models';
import CheckBoxGroup from '@/components/utils/CheckBoxGroup.vue';
import CheckBox from '@/components/utils/CheckBox.vue';

@Component({ components: { Popup, CheckBox, CheckBoxGroup } })
export default class AddOrEditSpacePopup extends Vue {
  @Prop() private dataServiceRef!: DataService;
  @Prop() private selectedSpace!: RoomSpace;
  @Prop() isSpaceEdit!: boolean;
  @Prop() isVisible!: boolean;

  newSpaceName = '';
  isNewSpaceReadyToAdd = false;
  addingSpaceErrorMessage = '';
  enableSpecificUse = false;

  /**
   * トライアル版の特定利用の設定が可能かどうか。
   */
  get specificUseConfigurable(): boolean {
    return this.$store.getters.isAdminUser && this.$store.getters.isTrialSite;
  }

  init(): void {
    this.clearAddingSpaceErrorMessage();
    this.clearAll();
    if (this.isSpaceEdit) {
      /* 編集 */
      this.newSpaceName = this.selectedSpace.name;
      this.enableSpecificUse = this.selectedSpace.spaceType === 'trial-specific-use';
    } else {
    }
    this.isNewSpaceReadyToAdd = false;

    setFocusToInput(this.$refs.popupInputRef);
  }

  private clearAll(): void {
    this.newSpaceName = '';
    this.isNewSpaceReadyToAdd = false;
    this.enableSpecificUse = false;
  }

  addOrEditSpace(): void {
    this.parseNewSpaceInput();
    const spaceType = this.enableSpecificUse ? 'trial-specific-use' : 'space';
    if (this.isNewSpaceReadyToAdd) {
      if (this.isSpaceEdit) {
        this.dataServiceRef.emitEditSpace(
          this.selectedSpace.id,
          this.newSpaceName,
          false,
          [],
          spaceType,
          this.onSpaceAddedOrEdited,
        );
      } else {
        this.dataServiceRef.emitAddSpace(this.newSpaceName, false, [], spaceType, this.onSpaceAddedOrEdited);
      }
      this.hidePopup();
    }
  }

  private onSpaceAddedOrEdited(error?: string) {
    if (error) {
      this.$toast.error(error);
    }
  }

  parseNewSpaceInput(): void {
    this.addingSpaceErrorMessage = '';
    const hasChange =
      this.hasSpaceTypeChanged() ||
      (!this.isSpaceEdit && !!this.newSpaceName) ||
      (this.isSpaceEdit && this.newSpaceName !== this.selectedSpace.name);
    if (!this.newSpaceName?.trim()) {
      this.addingSpaceErrorMessage = 'スペース名は必須です。';
    }
    if (this.isSpaceEdit && !this.hasSpaceTypeChanged() && this.newSpaceName === this.selectedSpace.name) {
      this.addingSpaceErrorMessage = 'スペース名を変更してください。';
    }
    if (this.addingSpaceErrorMessage) {
      this.isNewSpaceReadyToAdd = false;
    } else {
      //エラーがない時は入力に変更があれば追加可能状態にする。
      this.isNewSpaceReadyToAdd = hasChange;
    }
  }

  private onNewSpaceInputEnterClick(): void {
    this.parseNewSpaceInput();
    if (this.isNewSpaceReadyToAdd) {
      this.addOrEditSpace();
    }
  }

  private clearAddingSpaceErrorMessage(): void {
    this.addingSpaceErrorMessage = '';
  }

  onSpecificUseChecked() {
    this.enableSpecificUse = !this.enableSpecificUse;
    this.parseNewSpaceInput();
  }

  private hasSpaceTypeChanged(): boolean {
    if (this.isSpaceEdit) {
      return this.selectedSpace.spaceType === 'trial-specific-use' ? !this.enableSpecificUse : this.enableSpecificUse; //spaceTypeが変更されたら
    }
    return this.enableSpecificUse;
  }

  hidePopup(): void {
    this.clearAll();
    this.$emit('close');
  }
}
